import { SignupCarrier } from 'carrier/SignupCarrier';
import {
  createBrowserRouter,
  Navigate,
  redirect,
  useParams,
} from 'react-router-dom';
import { SelectProduct } from 'SelectProduct';

const CarrierRoute = () => {
  const params = useParams();

  const routeValues = [
    'create-account',
    'contact-info',
    'additional-info',
    'verify-usdot',
  ];

  if (!routeValues.includes(params.step || '')) {
    return <Navigate to="/carrier/create-account" />;
  }

  return <SignupCarrier routeValues={routeValues} />;
};

export const router = createBrowserRouter([
  {
    index: true,
    element: <SelectProduct />,
  },
  {
    path: '/shipper',
    loader: () => redirect('https://superdispatch.com/shipper-request-demo'),
  },
  {
    path: '/carrier/:step',
    children: [
      {
        index: true,
        element: <CarrierRoute />,
      },
      {
        path: '*',
        element: <Navigate to="/carrier/create-account" />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
]);
